import React from 'react';
import { IContext } from '../types';

const Context = React.createContext<IContext>(undefined);

export default Context;
